export default __webpack_public_path__ + "static/long-34df2cdd7225e14a8618b89368338c7a.jpeg";